import { WorkgridDatasource } from './interfaces'

export default function isDatasourceOwner(datasourceInstance: WorkgridDatasource | undefined, userId: string) {
  if (!datasourceInstance || !userId) return false

  return !!datasourceInstance.owners?.includes(userId)
}
